import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Home from "./features/Home";
import Img from "./features/Img";
import SelectionProjects from "./features/SelectionProjects";
import WoodEssence from "./features/WoodEssence";
import RelatedContent from "./features/RelatedContent";
import Testimonials from "./features/Testimonials";

export default () => {
	Home()
	Img()
	SelectionProjects()
	WoodEssence()
	RelatedContent()
	Testimonials()
};
